import React, { createContext, useState, useContext, useEffect } from 'react';
import { signOut as signOutAuth } from "utils/authentication";

const AuthContext = createContext({
  authData: null,
  signIn: (_authData: any) => { },
  signOut: () => { }
});

const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState(null);

  const signIn = (_authData: any) => {
    setAuthData(_authData);
  };

  const signOut = () => {
    setAuthData(null);
    signOutAuth();
  };

  // const getUserData = async () => {
  //   const authToken = await getToken();
  //   signIn(authToken);
  // }

  // useEffect(() => {
  //   getUserData();
  // }, []);

  return (
    <AuthContext.Provider value={{ authData, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};


const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export {
  AuthContext,
  AuthProvider,
  useAuth
};